import { Fragment } from 'react';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import useAthleteUserCredentials from './UseAthleteUserCredentials';

import AthleteUserCredentialsGrid from './AthleteUserCredentialsGrid';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteUserCredentials = () => {
  const { athleteEntryContextState, onNextButtonClicked, onSaveAndExitButtonClicked, onBackButtonClicked,
    omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState, orgUnitAthleteEntryInfoState, state,
    modalState, onAddCredential, onDeleteCredentialClicked, onModalCanceled, onDeleteCredential
  } = useAthleteUserCredentials();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_CREDENTIALS}
        onNextButtonClicked={onNextButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        errorMessage={state.error}>
        {athleteEntryContextState.isReadOnly === false ?
          <Fragment>
            <div className="row">
              <div className={athleteEntryContextState.isUnattached === true ? global.DisplayComponent : global.HideComponent}>
                <div className="col-xs-12 usas-extra-top-margin">
                  <ActionIntraPageButton type="button" onClick={onAddCredential}>Select Credential</ActionIntraPageButton>
                </div>
                <div className="col-xs-12">
                  <AthleteUserCredentialsGrid
                    gridData={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.arrayData}
                    isLoading={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading}
                    onDeleteCredentialClicked={onDeleteCredentialClicked}
                  />
                </div>
                <Fragment>
                  {omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.arrayData?.length > 5 && omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading === false &&
                    <div className='visible-md visible-lg'>
                      <div className="col-xs-12 usas-extra-top-margin">
                        <ActionIntraPageButton className="usas-extra-top-margin" type="button" onClick={onAddCredential}>Select Credential</ActionIntraPageButton>
                      </div>
                    </div>}
                  {omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.arrayData?.length > 0 && omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading === false &&
                    <div className='hidden-md hidden-lg'>
                      <div className="col-xs-12 usas-extra-top-margin">
                        <ActionIntraPageButton className="usas-extra-top-margin" type="button" onClick={onAddCredential}>Select Credential</ActionIntraPageButton>
                      </div>
                    </div>}
                </Fragment>
              </div>
            </div>
            <PopUpModal
              widthPct={90}
              maxWidth={720}
              title={modalState.modalTitle}
              displayPopUp={modalState.displayPopUp}
              onModalCanceled={onModalCanceled}>
              <div className="row">
                <div className="col-xs-12">
                  <p><strong>Name:</strong> {modalState?.credentialName}</p>
                  <p><strong>Organization:</strong> {modalState?.organization}</p>
                  <p><strong>Member Id:</strong> {modalState?.memberId}</p>
                  <p><strong>Email:</strong> {modalState?.email}</p>
                  <p><strong>Is In Good Standing?:</strong> {modalState?.isInGoodStanding}</p>
                  <p><strong>Good Standing Expiration Date:</strong> {modalState?.isInGoodStandingExpirationDate}</p>
                  <p><strong>Credential:</strong> {modalState?.typeName}</p>
                </div>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={(e) => onDeleteCredential(e, modalState.orgUnitAthleteEntryOrgUnitNonAthleteEntryId)}>Delete</PrimaryButton>
                </div>
              </div>
            </PopUpModal>
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading || orgUnitAthleteEntryInfoState.isObjLoading} />
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.SAVING_MSG}
              displayPopUp={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isSaving} />
          </Fragment >
          :
          <Fragment>
            <div className="row">
              <div className={athleteEntryContextState.isUnattached === true ? global.DisplayComponent : global.HideComponent}>
                <div className="col-xs-12">
                  <AthleteUserCredentialsGrid
                    gridData={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.arrayData}
                    isLoading={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading}
                  />
                </div>
              </div>
            </div>
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading} />
          </Fragment >
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default AthleteUserCredentials;